module.exports = __webpack_public_path__ + "img/scale.cd424aff.svg";